export default __webpack_public_path__ + "static/media/Bronze-penny.ef09e4dc.svg";